module.exports = __webpack_public_path__ + "static/media/whistle.f3291d73.svg";